import React from 'react';
import { withRouter, WithRouterProps } from 'react-router';
import bind from '../bind';
import SearchInputGroup from '../cms/search_input_group';
import { withUpdateURL, IUpdateURLProps } from './with_update_url';
import { Filter, filterID, FilterProps } from './search_filters';
import { MParticleEventName } from '../elog/mparticle_types';
import { trackEvent } from '../elog/mparticle_tracker';

interface IState {
  text: string;
}

function getValue(filter: Filter) {
  return filter.options[0].setValues[0];
}

type IProps = FilterProps & WithRouterProps & IUpdateURLProps;

export class TextInputFacet extends React.Component<IProps, IState> {

  constructor(props: IProps) {
    super(props);
    this.state = { text: getValue(props.filter) || '' };
  }

  UNSAFE_componentWillReceiveProps(nextProps: IProps) {
    const newValue = getValue(nextProps.filter);

    if (newValue !== getValue(this.props.filter)) {
      this.setState({ text: newValue });
    }
  }

  @bind
  handleSubmit(evt) {
    if (evt) evt.preventDefault();

    const { paramName } = this.props.filter.options[0];

    const newUrl = this.props.updateUrl(
      this.props.location,
      {
        [paramName]: this.state.text,
      },
    );

    trackEvent({
      componentName: 'TextInputFacet',
      eventName: MParticleEventName.ClickedSearchFilter,
      displayStyle: this.state.text,
      selected: true,
      parent: paramName,
      query: this.state.text,
    });

    this.props.router.push(newUrl);
  }

  @bind
  handleClear() {
    this.setState({ text: '' }, () => {
      // Submit on clear if there is currently a non-empty filter applied
      if (getValue(this.props.filter)) this.handleSubmit(null);
    });
  }

  @bind
  handleChange(evt) {
    this.setState({ text: evt.target.value });
  }

  render() {
    const id = `${this.props.pageSection}--${filterID(this.props.filter)}`;

    return (
      <div className="facet">
        <label
          htmlFor={id}
          className="facet__heading"
        >
          {this.props.filter.name}
        </label>
        <SearchInputGroup
          onSubmit={this.handleSubmit}
          onChange={this.handleChange}
          onClear={this.handleClear}
          value={this.state.text}
          id={id}
        />
      </div>
    );
  }
}

export default withRouter<FilterProps>(withUpdateURL(TextInputFacet));
